import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DataSyncService {
  refetchVersionListener$: BehaviorSubject<number> =
    new BehaviorSubject<number>(0);

  // Changed from BehaviorSubject to Subject to prevent initial emission
  creditCardCreatedListener$: Subject<number> = new Subject<number>();

  public getRefetchVersionListener() {
    return this.refetchVersionListener$;
  }

  public getCreditCardCreatedListener() {
    return this.creditCardCreatedListener$;
  }

  public notifyCreditCardCreated() {
    this.creditCardCreatedListener$.next(Date.now());
  }
}
